// build v2
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n/index';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,          // data stays fresh for 30s — no pointless refetch on tab switch
      cacheTime: 10 * 60 * 1000,     // keep unused data in memory for 10 min
      // Local installs have no internet → navigator.onLine === false, but the API is on
      // localhost and reachable. Default networkMode 'online' PAUSES queries/mutations
      // when the browser is offline, so settings saves (e.g. exchange rate) silently
      // never fired. 'always' fires regardless; real network failures still error out.
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);